import axios from 'axios';
import { ApiStatus } from 'Enums';
import { getSessionObject } from 'Utilities/storage';
const handleGetConnections = async () => {
  const mockServerUrl = getSessionObject('getConnections');
  if (mockServerUrl) {
    const resp = await axios.get(mockServerUrl);
    return resp;
  }
  return {
    status: ApiStatus.OK,
    data: {}
  };
};
export const libreHandlers = [{
  match: /connections$/,
  handle: handleGetConnections,
  method: 'GET',
  name: 'getConnections'
}];